import { render, staticRenderFns } from "./MediaTree.vue?vue&type=template&id=5ba4d745&scoped=true&"
import script from "./MediaTree.vue?vue&type=script&lang=js&"
export * from "./MediaTree.vue?vue&type=script&lang=js&"
import style0 from "./MediaTree.vue?vue&type=style&index=0&id=5ba4d745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4d745",
  null
  
)

export default component.exports